export const recoveryInProgress = (stage) => ['diagnosing', 'repairing', 'retrying', 'verifying'].includes(stage);

export const dagRecoveryInProgress = (runtime) => recoveryInProgress(runtime?.recovery?.stage)
  && Number(runtime.recovery.expiresAt || Infinity) > Date.now();

export const recoveryExpiresAt = (event, startedAt, now = Date.now()) => {
  const deadline = Date.parse(event?.deadline_at);
  if (Number.isFinite(deadline)) return deadline + 60000;
  const start = Date.parse(event?.created_at || startedAt);
  const seconds = Number(event?.timeout_seconds);
  return (Number.isFinite(start) ? start : now)
    + (Number.isFinite(seconds) && seconds > 0 ? Math.min(seconds, 1800) : 1800) * 1000 + 60000;
};

export const appendRecoveryEvents = (previous, incoming) => {
  const events = [...(previous || [])];
  (incoming || []).forEach((event) => {
    const last = events[events.length - 1];
    if (event.heartbeat && last?.heartbeat && last.stage === event.stage
      && last.activity === event.activity && last.attempt === event.attempt) events[events.length - 1] = event;
    else events.push(event);
  });
  return events.slice(-128);
};

export const actionRecoveryMessage = (event, t) => {
  const activities = ['starting', 'connecting', 'thinking', 'reading', 'writing', 'checking',
    'validation_passed', 'validation_failed', 'model_retry', 'completed'];
  if (recoveryInProgress(event?.stage) && activities.includes(event?.activity)) {
    return t(`action_recovery.progress.${event.activity}`);
  }
  const key = recoveryInProgress(event?.stage) ? event.stage : event?.reason || event?.stage;
  return t(`action_recovery.${key}`, t('action_recovery.needs_review'), {
    minutes: Math.max(1, Math.ceil(Number(event?.retry_after_seconds || 600) / 60)),
  });
};

export const recoveryCounts = (record) => {
  const candidates = Array.isArray(record?.candidates) ? record.candidates : null;
  const latest = record?.events?.[record.events.length - 1];
  const count = (value) => Number.isInteger(value) && value >= 0 ? value : null;
  return {
    attempts: count(record?.repair_attempt_count) ?? count(latest?.repair_attempt_count) ?? (candidates
      ? Math.max(0, ...candidates.map((candidate) => count(candidate.attempt) || 0),
        ...(record?.events || []).filter((event) => event.stage === 'repairing').map((event) => count(event.attempt) || 0))
      : null),
    proposals: count(record?.proposal_count) ?? count(latest?.proposal_count) ?? candidates?.length ?? null,
    executions: count(record?.execution_count) ?? count(latest?.execution_count) ?? (candidates
      ? candidates.filter((candidate) => ['execution_started', 'executed', 'failed', 'verified', 'recovered', 'recovered_for_run'].includes(candidate.state)).length
      : null),
  };
};
